<!--
	ApiArrayChip.svelte

    These are used in the ApiArrayFieldEditor.
-->

<script>
    import { onMount } from 'svelte';

    // TCARE components

    // SMUI components
    import { Icon } from '@smui/icon-button';
	import { Svg } from '@smui/common/elements';
	import { mdiCloseCircleOutline } from '@mdi/js';

    export let item;
    export let onChipClick;
    

    onMount(() => {
    })

</script>

<style>
    .array-chip {
        height: fit-content;
        width: fit-content;
        display: flex;
        align-items: center;
        padding: 4px 4px;
        margin: 0px 3px 3px 0px;
        font-size: .9em;
        color: var(--tcare-white);
        background-color: var(--tcare-purple);
        border-radius: 10px;
        user-select: none;
    }

    .array-chip .chip-label {
        margin: 0px 2px;
        color: var(--tcare-white);
    }

    .array-chip:hover {
        background-color: var(--tcare-secondary);
    }

    :global(.array-chip svg) {
        width: 20px !important;
        height: 20px !important;
        fill: var(--tcare-white);
        outline: none;
    }

    @media screen and (max-width: 600px) {
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>

<div class="array-chip" on:click={() => onChipClick(item)}  >
    <div class="chip-label">{item}</div>
    <Icon component={Svg} viewBox="0 0 24 24" ><path d={mdiCloseCircleOutline} /></Icon>
</div>
